import { atom } from "recoil";

export const adminLogoAtom = atom({
  key: "adminLogo",
  default: null,
});

export const filterKeys = atom({
  key: "filterKeys",
  default: {
    page: 1,
    pageSize: 10,
    search: "",
    verified: "",
  },
});
export const pageInformation = atom({
  key: "pageInformation",
  default: null,
});
